import { forwardRef, PropsWithChildren, HTMLAttributes } from "react";
import styled from "@emotion/styled";

type AppearAnimatorProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    visible: boolean;
  }
>;

export const AppearAnimator = forwardRef<HTMLDivElement, AppearAnimatorProps>(
  function AppearAnimator({ children, visible, ...rest }, ref) {
    return (
      <StyledAppearAnimator ref={ref} data-mds-name="appear-animator" $visible={visible} {...rest}>
        {children}
      </StyledAppearAnimator>
    );
  }
);

const StyledAppearAnimator = styled.div<{ $visible: boolean }>`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
`;
